import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '../index';

interface PlatformState {
  selectedPlatformId: string | 'ALL';
}

const initialState: PlatformState = {
  selectedPlatformId: 'ALL',
};

export const platformSlice = createSlice({
  name: 'platform',
  initialState,
  reducers: {
    setSelectedPlatformId: (state, action: PayloadAction<string | 'ALL'>) => {
      state.selectedPlatformId = action.payload;
    },
  },
});

export const { setSelectedPlatformId } = platformSlice.actions;

// Selector that returns undefined when 'ALL', else the id.
// This is the single source of truth every consumer reads from.
export const selectPlatformIdParam = (state: RootState) =>
  state.platform.selectedPlatformId === 'ALL' ? undefined : state.platform.selectedPlatformId;

export const platformReducer = platformSlice.reducer;
